import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useUserStore } from "../../stores/user";
import { Input } from '../../widgets/input';
import styles from './auth.module.css';

export function Auth(props){
    const { register } = props;
    const navigate = useNavigate();
    const { createUser, login, initiateDolby, getFB, load } = useUserStore();
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState([]);
    const [registrationComplete, setRegistrationComplete] = useState(false);
    const [isRegistering, setIsRegistering] = useState(false);
    return (
        <div className={styles.container}>
            {!register && <div className={styles.auth}>
                <h1>Log in to Office Talk<span>.</span></h1>
                <p>Give your First name and Last name to proceed</p>
                <form onSubmit={async e => {
                    e.preventDefault();
                    try{
                        setIsRegistering(true);
                        await login(firstName, lastName);
                        initiateDolby()
                        .then(async () => {
                            await getFB();
                            const redirect = new URLSearchParams(window.location.search).get('r');
                            setIsRegistering(false);
                            console.log('REDIRECT', redirect);
                            if(redirect){
                                if(redirect === '/' || redirect === '/auth'){
                                    navigate(`/spaces`);
                                }
                                else{
                                    navigate(redirect);
                                }
                            }
                            else{
                                navigate(`/spaces`);
                            }
                        });
                    }
                    catch(ex){
                        setErrors([ex.message]);
                        setIsRegistering(false);
                    }
                }}>
                    <div className={styles.login}>
                        <Input id="firstName" label="First Name" value={firstName} onChange={e => setFirstName(e.target.value)} />
                        <Input id="lastName" label="Last Name" value={lastName} onChange={e => setLastName(e.target.value)} />
                        {errors.length > 0 && <div className={styles.errors}>{errors.map(error => <span key={error}>{error}</span>)}</div>}
                        <div className={styles.actions}>
                            <button className={`${isRegistering ? styles.disabled : ''}`} type="submit">Proceed</button>
                        </div>
                    </div>
                </form>
            </div>}
            {register && <div className={styles.auth}>
                <h1>Create new account<span>.</span></h1>
                <p>Already a member? <Link to="/auth">Log in</Link></p>
                {registrationComplete && <div className={styles.success}>
                    <p>Registration complete!</p>
                    <p>Please check your email for a verification link.</p>
                </div>}
                {!registrationComplete && <form onSubmit={async e => {
                    e.preventDefault();
                    await createUser({firstName, lastName, email, password});
                    setRegistrationComplete(true);
                }}>
                    <div className={styles.register}>
                        <div className={styles.inputgroup}>
                            <Input id="firstname" label="First name" value={firstName} onChange={e => setFirstName(e.target.value)} error="Invalid value" />
                            <Input id="lastname" label="Last name" value={lastName} onChange={e => setLastName(e.target.value)} />
                        </div>
                        <Input id="email" label="Email address" value={email} onChange={e => setEmail(e.target.value)} />
                        <Input id="password" label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} />
                        {errors.length > 0 && <div className={styles.errors}>{errors.map(error => <span key={error}>{error}</span>)}</div>}
                        <div className={styles.actions}>
                            <button type="submit">Create Account</button>
                        </div>
                    </div>
                </form>}
            </div>}
        </div>
    );
}

